exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".data-lack[data-v-e8a927ba]{margin-top:13px;line-height:1}.data-lack .data-lack-content[data-v-e8a927ba]{text-align:center;font-size:12px;padding:7px 0;background:rgba(255,229,108,.31);border-radius:28px}.data-lack .data-lack-content .icon[data-v-e8a927ba]{display:inline-block;width:12px;height:12px;border-radius:100%;background-color:#ff8607;color:#fff}.data-lack .data-lack-content .character[data-v-e8a927ba]{padding-left:6px;color:#f23}", ""]);

// exports
